/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-12-26T11:31:09.441
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getReportRentContractRequestCheckoutLeaseEditInit,
	getReportRentContractRequestCheckoutLeaseView
} from '@api/report/ReportRentContractRequestCheckoutLease';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getReportRentContractRequestCheckoutLeaseEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportRentContractRequestCheckoutLeaseEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getReportRentContractRequestCheckoutLeaseView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportRentContractRequestCheckoutLeaseView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
